






























import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { getTileMaxHeight } from '@/utils/appstore'
import { App, InitApp } from '@/pages/appstore/entities/app'
import { tabTypes } from '@/pages/appstore/entities/subMenu'
import AppstoreAppTile from '@/pages/appstore/components/Basics/AppstoreAppTile.vue'
import DraggableCarousel from '@/components/DraggableCarousel.vue'
import { debounce } from '@/utils/function'

@Component<AppTileCarousel>({
    components: {
        AppstoreAppTile,
        DraggableCarousel
    }
})
export default class AppTileCarousel extends Vue {
    public maxTitleHeight = 'auto'
    public maxBodyHeight = 'auto'
    public localCurrentApps: App[] = []

    @Prop({ type: Array, required: true })
    public readonly currentApps!: App[]
    @Prop({ type: Boolean, required: false })
    public readonly canAccessEditor?: boolean

    private debouncedSetTilesHeights = debounce(this.setTilesHeights, 200, false)

    public get tabTypes() {
        return tabTypes
    }

    @Watch('currentApps')
    public watchCurAppApps() {
        this.localCurrentApps = [InitApp, ...this.currentApps]
        this.resizeTilesHeights()
    }

    public getShowAppstoreAppTile(index: number): boolean {
        return index === 0 && this.canAccessEditor || index > 0
    }

    public setTilesHeights() {
        const resized = getTileMaxHeight('availableAppContainer', 'availableAppTitle', 'availableAppBody')
        this.maxTitleHeight = resized.maxTitleHeight
        this.maxBodyHeight = resized.maxBodyHeight
    }

    public resizeTilesHeights() {
        this.maxTitleHeight = 'auto'
        this.maxBodyHeight = 'auto'
        setTimeout(this.debouncedSetTilesHeights, 0.1)
    }

    public changeCurAppAppsOrder(value) {
        this.localCurrentApps = value
        this.$emit('changeCurAppAppsOrder', value)
    }

    public async mounted() {
        this.localCurrentApps = [InitApp, ...this.currentApps]
        this.resizeTilesHeights()
        window.addEventListener('resize', this.resizeTilesHeights)
    }

    private beforeDestroy() {
        window.removeEventListener('resize', this.resizeTilesHeights)
    }
}
